import React, { useRef, useState, useContext, useEffect } from 'react';
import { Link, Redirect, Route, Switch } from 'react-router-dom';
import {
    setupIonicReact, IonApp,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonFooter,
    IonMenu,
    IonList,
    IonListHeader,
    IonMenuToggle,
    IonIcon,
    IonLabel,
    IonPage,
    IonButtons,
    IonButton,
    IonItem,
    IonMenuButton,
    IonTabs,
    IonRouterOutlet,
    IonTabButton,
    IonTabBar,
    useIonModal,
    IonRow,
    IonBadge,
    IonFab, IonFabButton
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import {
    ellipse, square, triangle, cube, albums, home, person, power, logInOutline, logOut, lockOpenOutline, lockClosed,
    checkmark, chatbox, business, notificationsOutline, listCircleOutline, desktopOutline, settingsSharp, paperPlane,
    chatboxEllipsesOutline,
    downloadOutline,
    logoAppleAppstore,
    logoGooglePlaystore,
    openOutline,
    cart
} from 'ionicons/icons';

import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { StatusBar } from '@capacitor/status-bar';

import Home from './pages/Home';
import Map from './pages/Map';
import AgentMap from './pages/AgentMap';
import Auth from './pages/Auth';
import AuthReset from './pages/AuthReset';
import Contact from './pages/Contact';
import Notice from './pages/Notice';
import MarkerDetails from './pages/MarkerDetails';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

import './App.css';

import api from './data/axios';

import AuthContext from "./UserContext";
import MyAccount from "./pages/MyAccount";
import NotFound from "./components/NotFound";
import TermsAndConditions from './pages/Terms';

import InstallButton from './components/InstallPWAButton';

setupIonicReact(
	{
		mode: 'md',
	}
);

const App: React.FC = () => {

    const { authValues, logout } = useContext(AuthContext);

    function handleLogOut() {

        logout();

        window.location.reload();

    }

    const [isAndroid, setIsAndroid] = useState(false);
	const [isIOS, setIsIOS] = useState(false);

	useEffect(() => {

        const userAgent = navigator.userAgent || navigator.vendor;

		// Detect Android
		if (/android/i.test(userAgent)) {
			setIsAndroid(true);
		}

		// Detect iOS
        if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
			setIsIOS(true);
		}
	}, []);

	const isAppInstalled = () => {
		// Check if the app is installed on iOS
        if ((window.navigator as any).standalone) {
			return true;
		}

		// Check if the app is installed on Android
		let isInstalled = false;
		window.addEventListener('beforeinstallprompt', (e) => {
			e.preventDefault();
			isInstalled = true;
		});

		return isInstalled;
	};

	const appInstalled = isAppInstalled();

    return (
        <IonApp>
            <IonPage className="ion-page" id="main-content">
                <IonReactRouter>
                    <IonHeader>
                        {/*Capacitor.isNativePlatform() && (
                            <div style={{
                                height: 'env(safe-area-inset-top)'
                            }}></div>
                        )*/}
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton slot="start">
                                    <IonMenuButton color="drukre"></IonMenuButton>
                                </IonButton>
                                <Link to="/" style={{ textDecoration: 'none' }}>
                                    <IonTitle color="drukre">Druk Real Estate</IonTitle>
                                </Link>
                            </IonButtons>
                            {authValues.authenticated == false ?
                                <IonButtons slot="end" class="ion-padding-horizontal">
                                    <Link to="/login" className="header-link">
                                        <IonButton id="open-login">
                                            <IonIcon color="drukre" icon={logInOutline}></IonIcon>
                                            <IonLabel class="ion-hide-md-down">Log In</IonLabel>
                                        </IonButton>
                                    </Link>
                                    |
                                    <Link to="/register" className="header-link">
                                        <IonButton id="open-login">
                                            <IonIcon color="drukre" icon={lockOpenOutline}></IonIcon>
                                            <IonLabel class="ion-hide-md-down">Register</IonLabel>
                                        </IonButton>
                                    </Link>
                                </IonButtons>
                                :
                                <IonButtons slot="end" class="ion-padding-horizontal">
                                    <Link to="/myaccount" className="header-link" title={authValues.user.data.user.name}>
                                        <IonButton className="ion-hide-md-down">
                                            <IonIcon color="drukre" icon={settingsSharp} />
                                            <IonLabel>Hi {authValues.user.data.user.name}</IonLabel>
                                        </IonButton>
                                    </Link>
                                    <Link to="/agentmap" className="header-link">
                                        <IonButton className="ion-hide-md-down">
                                            <IonIcon color="drukre" icon={listCircleOutline} />
                                            <IonLabel>My Listings</IonLabel>
                                        </IonButton>
                                    </Link>
                                    <Link to="#" className="header-link">
                                        <IonButton className="ion-hide-md-down">
                                            <IonIcon color="drukre" icon={notificationsOutline} />
                                            <IonBadge color="danger">5</IonBadge>
                                            <IonLabel>Notifications</IonLabel>
                                        </IonButton>
                                    </Link>
                                    <Link to="#" className="header-link" onClick={handleLogOut}>
                                        <IonButton onClick={() => handleLogOut()}>
                                            <IonIcon color="drukre" icon={logOut} />
                                            <IonLabel>Log Out</IonLabel>
                                        </IonButton>
                                    </Link>
                                </IonButtons>
                            }
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding">

                    </IonContent>

                    <IonMenu content-id="main">
                        <IonHeader>
                            <IonToolbar color="drukre">
                                <IonTitle>Menu</IonTitle>
                            </IonToolbar>
                        </IonHeader>

                        <IonContent>
                            <IonList>
                                <IonListHeader>
                                    Navigate
                                </IonListHeader>
                                <IonMenuToggle auto-hide="false">
                                    <Link to="/" className="header-link" style={{ textDecoration: 'none' }}>
                                        <IonItem button routerDirection="none">
                                            <IonIcon color="drukre" slot="start" icon={home}></IonIcon>
                                            <IonLabel>Home</IonLabel>
                                        </IonItem>
                                    </Link>
                                    <Link to="/map/sale" className="header-link" style={{ textDecoration: 'none' }}>
                                        <IonItem button>
                                            <IonIcon color="drukre" slot="start" icon={business}></IonIcon>
                                            <IonLabel>
                                                Buy
                                            </IonLabel>
                                        </IonItem>
                                    </Link>
                                    <Link to="/map/rent" className="header-link" style={{ textDecoration: 'none' }}>
                                        <IonItem button>
                                            <IonIcon color="drukre" slot="start" icon={albums}></IonIcon>
                                            <IonLabel>
                                                Rent
                                            </IonLabel>
                                        </IonItem>
                                    </Link>
                                    <Link to="/agentmap" className="header-link" style={{ textDecoration: 'none' }}>
                                        <IonItem button>
                                            <IonIcon color="drukre" slot="start" icon={paperPlane}></IonIcon>
                                            <IonLabel>
                                                Post Yours
                                            </IonLabel>
                                        </IonItem>
                                    </Link>
                                    <Link to="/contact" className="header-link" style={{ textDecoration: 'none' }}>
                                        <IonItem button>
                                            <IonIcon color="drukre" slot="start" icon={chatboxEllipsesOutline}></IonIcon>
                                            <IonLabel>
                                                Contact Us
                                            </IonLabel>
                                        </IonItem>
                                    </Link>
                                    <a href="https://ethrom.org" target="_blank" rel="noopener noreferrer" className="header-link" style={{ textDecoration: 'none' }}>
                                        <IonItem button>
                                            <IonIcon color="drukre" slot="start" icon={cart}></IonIcon>
                                            <IonLabel>
                                                Shopping
                                            </IonLabel>
                                        </IonItem>
                                    </a>
                                </IonMenuToggle>
                            </IonList>
                        </IonContent>
                        <IonFooter style={{ marginBottom: '100px' }}>
							<IonContent className="ion-padding"
								style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
								<span slot="fixed">
									{isAndroid && (
										appInstalled ? (
											<IonButton href="your-app-url" target="_blank">
												<IonIcon icon={logoGooglePlaystore}></IonIcon> Access on PlayStore <IonIcon icon={openOutline}></IonIcon>
											</IonButton>
										) : (
											<IonButton href="https://play.google.com/store/apps/details?id=com.drukrealestate" target="_blank">
												<IonIcon icon={logoGooglePlaystore}></IonIcon> Access on PlayStore <IonIcon icon={downloadOutline}></IonIcon>
											</IonButton>
										)
									)}
									{isIOS && (
										appInstalled ? (
											<IonButton href="https://apps.apple.com/us/app/druk-real-estate/id6740314487" target="_blank">
												<IonIcon icon={logoAppleAppstore}></IonIcon> Access on AppStore <IonIcon icon={openOutline}></IonIcon>
											</IonButton>
										) : (
											<IonButton href="https://apps.apple.com/us/app/druk-real-estate/id6740314487" target="_blank">
												<IonIcon icon={logoAppleAppstore}></IonIcon> Access on AppStore <IonIcon icon={downloadOutline}></IonIcon>
											</IonButton>
											/*
											<p>To install this app, tap the <IonIcon icon={shareOutline} /> button and then "Add to Home Screen".</p>
											*/
										)
									)}
									{!isAndroid && !isIOS && (
										<InstallButton />
									)}
								</span>
							</IonContent>
						</IonFooter>
                    </IonMenu>

                    <IonTabs>
                        <IonRouterOutlet id="main">
                            <Route path="/" exact={true} component={Home}></Route>
                            <Route path="/home" exact={true} component={Home} />
                            <Route path="/map" exact={true} >
                                <Map />
                            </Route>
                            <Route path="/map/:type" exact={true} >
                                <Map />
                            </Route>

                            <Route path="/agentmap" exact={true}>
                                <AgentMap />
                            </Route>
                            {/*authValues.authenticated ?
                            <Route exact path="/agentmap" component={AgentMap} />
                            : 
                            <Route exact path="/agentmap" render={()=> <Redirect to="/login" />} />
                            */}
                            <Route path="/terms-and-conditions" exact={true}>
                                <TermsAndConditions />
                            </Route>

                            <Route path='/login' exact={true} component={Auth} />
                            <Route path='/register' exact={true} component={Auth} />
                            <Route path='/password-reset-request' exact={true} component={Auth} />
                            <Route path='/resetpassword/:token' exact={true} component={AuthReset} />
                            <Route exact path='/myaccount' component={MyAccount} />

                            <Route exact path="/contact" component={Contact} />
                            <Route exact path="/notice" component={Notice} />
                            <Route exact path="/markerdetails/:id" component={MarkerDetails} />
                            <Route exact path='/verify/:code' component={Auth} />
                            <Route exact path='/social-auth-callback' component={Auth} />
                            {/*
                            <Route path="*">
                                <NotFound />
                            </Route>
                            */}
                        </IonRouterOutlet>
                        {authValues.authenticated ?
                            <IonTabBar slot="bottom" className="ion-hide-md-up">
                                <IonTabButton tab="tab3" href="/agentmap">
                                    <IonIcon color="drukre" icon={listCircleOutline} />
                                    <IonLabel>My Listings</IonLabel>
                                </IonTabButton>
                                <IonTabButton tab="tab2" href="#">
                                    <IonIcon color="drukre" icon={notificationsOutline} />
                                    <IonBadge color="danger">5</IonBadge>
                                    <IonLabel>Notifications</IonLabel>
                                </IonTabButton>
                                <IonTabButton tab="tab1" href="/myaccount">
                                    <IonIcon color="drukre" icon={settingsSharp} />
                                    <IonLabel>Account</IonLabel>
                                </IonTabButton>
                            </IonTabBar>
                            :
                            <IonTabBar slot="bottom" className="ion-hide-md-up">
                                <IonTabButton tab="tab2" href="#">
                                    <IonIcon color="drukre" icon={notificationsOutline} />
                                    <IonBadge color="danger">5</IonBadge>
                                    <IonLabel>Notifications</IonLabel>
                                </IonTabButton>
                            </IonTabBar>
                        }
                    </IonTabs>
                </IonReactRouter>
            </IonPage>
        </IonApp>
    )
}

export default App;
